//import api from '@/api/mock';
import API from '@aws-amplify/api';
export default {
  namespaced: true,
  state: {
    gateways: null,
    loading: false
  },
  mutations: {
    loading(state, payload) {
      state.loading = payload;
      //console.log('Setting loading to: ' + payload);
    },
    set(state, gateways) {
      state.gateways = gateways;
      console.log('Set internal gateways: ', gateways);
    }
  },
  actions: {
    async load({ commit, state }) {
      try {
        const gateways = await API.get('ipWayAPI', '/user/flats', {});
        gateways.forEach(gateway => {
          gateway.gw = gateway.flat.split('/')[0];
          gateway.flt = gateway.flat.split('/')[1];
          if (!('doNotDisturb' in gateway)) gateway.doNotDisturb = false;
        });
        commit('set', gateways);
        commit('loading', false);
      } catch (err) {
        console.log(err);
        commit('set', []);
        commit('loading', false);
      }
      return state.gateways;
    },
    async fetch({ commit, dispatch, state }) {
      if (state.gateways == null) {
        console.log('fetching gateways list');
        commit('loading', true);
        await dispatch('load');
      }
      return state.gateways;
    },
    async get({ dispatch, state }, index) {
      await dispatch('fetch');
      return state.gateways[index];
    },
    add({ commit, dispatch }, { code, title }) {
      console.log('add gateway/flat to current account');
      commit('loading', true);
      return API.post('ipWayAPI', '/user/flat', {
        body: {
          title: title,
          code: code
        }
      }).then(() => {
        dispatch('load');
      });
    },
    delete({ commit, dispatch }, { flat }) {
      console.log('add gateway/flat to current account');
      commit('loading', true);
      return API.del('ipWayAPI', '/user/flat', {
        body: {
          flat: flat
        }
      }).then(() => {
        dispatch('load');
      });
    },
    put({ state }, { flat, title, doNotDisturb }) {
      console.log('putting info about flat gateway');
      //commit('loading', true);
      return API.put('ipWayAPI', '/user/flat/info', {
        body: {
          title: title,
          flat: flat,
          doNotDisturb: doNotDisturb
        }
      }).then(() => {
        //dispatch('load');
        state.gateways.forEach(gateway => {
          if (gateway.flat == flat) {
            if (title != undefined) gateway.title = title;
            if (doNotDisturb != undefined) gateway.doNotDisturb = doNotDisturb;
          }
        });
      });
    },
    async getUploadUrl(context, gw_flat) {
      const { Url } = await API.get(
        'ipWayAPI',
        '/user/flats/' + gw_flat + '/image/uploadurl'
      );
      return Url;
    },
    ['awsauth/setUser']: {
      root: true,
      handler({ commit }, user) {
        //on logout clear gateway from list
        if (!user) {
          commit('set', null);
        }
      }
    }
  }
};
